// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3x0Np","notes":"Notes_notes__3st7E","note":"Notes_note__1oqIX","markdown":"Notes_markdown__DRLtv"};